import { Link, useNavigate } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';

// Mock data for Australian suburbs with postcodes - Major cities and suburbs across all states
const australianSuburbs = [
  // NSW - Major suburbs
  { suburb: 'Sydney', postcode: '2000', state: 'NSW' },
  { suburb: 'Parramatta', postcode: '2150', state: 'NSW' },
  { suburb: 'Bondi', postcode: '2026', state: 'NSW' },
  { suburb: 'Bondi Beach', postcode: '2026', state: 'NSW' },
  { suburb: 'Bondi Junction', postcode: '2022', state: 'NSW' },
  { suburb: 'Newtown', postcode: '2042', state: 'NSW' },
  { suburb: 'Surry Hills', postcode: '2010', state: 'NSW' },
  { suburb: 'Penrith', postcode: '2750', state: 'NSW' },
  { suburb: 'Mascot', postcode: '2020', state: 'NSW' },
  { suburb: 'Blacktown', postcode: '2148', state: 'NSW' },
  { suburb: 'North Sydney', postcode: '2060', state: 'NSW' },
  { suburb: 'Rose Bay', postcode: '2029', state: 'NSW' },
  { suburb: 'Mona Vale', postcode: '2103', state: 'NSW' },
  { suburb: 'Campbelltown', postcode: '2560', state: 'NSW' },
  { suburb: 'Liverpool', postcode: '2170', state: 'NSW' },
  { suburb: 'Camden', postcode: '2570', state: 'NSW' },
  { suburb: 'Narellan', postcode: '2567', state: 'NSW' },
  { suburb: 'Chatswood', postcode: '2067', state: 'NSW' },
  { suburb: 'Manly', postcode: '2095', state: 'NSW' },
  { suburb: 'Cronulla', postcode: '2230', state: 'NSW' },
  { suburb: 'Randwick', postcode: '2031', state: 'NSW' },
  { suburb: 'Paddington', postcode: '2021', state: 'NSW' },
  { suburb: 'Darlinghurst', postcode: '2010', state: 'NSW' },
  { suburb: 'Redfern', postcode: '2016', state: 'NSW' },
  { suburb: 'Glebe', postcode: '2037', state: 'NSW' },
  { suburb: 'Balmain', postcode: '2041', state: 'NSW' },
  { suburb: 'Leichhardt', postcode: '2040', state: 'NSW' },
  { suburb: 'Marrickville', postcode: '2204', state: 'NSW' },
  { suburb: 'Strathfield', postcode: '2135', state: 'NSW' },
  { suburb: 'Burwood', postcode: '2134', state: 'NSW' },
  { suburb: 'Ashfield', postcode: '2131', state: 'NSW' },
  { suburb: 'Hurstville', postcode: '2220', state: 'NSW' },
  { suburb: 'Kogarah', postcode: '2217', state: 'NSW' },
  { suburb: 'Rockdale', postcode: '2216', state: 'NSW' },
  { suburb: 'Bankstown', postcode: '2200', state: 'NSW' },
  { suburb: 'Auburn', postcode: '2144', state: 'NSW' },
  { suburb: 'Homebush', postcode: '2140', state: 'NSW' },
  { suburb: 'Ryde', postcode: '2112', state: 'NSW' },
  { suburb: 'Epping', postcode: '2121', state: 'NSW' },
  { suburb: 'Castle Hill', postcode: '2154', state: 'NSW' },
  { suburb: 'Newcastle', postcode: '2300', state: 'NSW' },
  { suburb: 'Wollongong', postcode: '2500', state: 'NSW' },
  { suburb: 'Central Coast', postcode: '2250', state: 'NSW' },
  { suburb: 'Gosford', postcode: '2250', state: 'NSW' },
  { suburb: 'Wyong', postcode: '2259', state: 'NSW' },
  { suburb: 'Hornsby', postcode: '2077', state: 'NSW' },
  { suburb: 'Dee Why', postcode: '2099', state: 'NSW' },
  { suburb: 'Brookvale', postcode: '2100', state: 'NSW' },
  { suburb: 'Mosman', postcode: '2088', state: 'NSW' },
  { suburb: 'Neutral Bay', postcode: '2089', state: 'NSW' },
  
  // VIC - Major suburbs
  { suburb: 'Melbourne', postcode: '3000', state: 'VIC' },
  { suburb: 'Carlton', postcode: '3053', state: 'VIC' },
  { suburb: 'Fitzroy', postcode: '3065', state: 'VIC' },
  { suburb: 'Richmond', postcode: '3121', state: 'VIC' },
  { suburb: 'South Yarra', postcode: '3141', state: 'VIC' },
  { suburb: 'St Kilda', postcode: '3182', state: 'VIC' },
  { suburb: 'Brighton', postcode: '3186', state: 'VIC' },
  { suburb: 'Caulfield', postcode: '3162', state: 'VIC' },
  { suburb: 'Glen Waverley', postcode: '3150', state: 'VIC' },
  { suburb: 'Box Hill', postcode: '3128', state: 'VIC' },
  { suburb: 'Doncaster', postcode: '3108', state: 'VIC' },
  { suburb: 'Ringwood', postcode: '3134', state: 'VIC' },
  { suburb: 'Dandenong', postcode: '3175', state: 'VIC' },
  { suburb: 'Frankston', postcode: '3199', state: 'VIC' },
  { suburb: 'Geelong', postcode: '3220', state: 'VIC' },
  { suburb: 'Ballarat', postcode: '3350', state: 'VIC' },
  { suburb: 'Bendigo', postcode: '3550', state: 'VIC' },
  { suburb: 'Footscray', postcode: '3011', state: 'VIC' },
  { suburb: 'Werribee', postcode: '3030', state: 'VIC' },
  { suburb: 'Sunshine', postcode: '3020', state: 'VIC' },
  { suburb: 'Preston', postcode: '3072', state: 'VIC' },
  { suburb: 'Coburg', postcode: '3058', state: 'VIC' },
  { suburb: 'Brunswick', postcode: '3056', state: 'VIC' },
  { suburb: 'Northcote', postcode: '3070', state: 'VIC' },
  { suburb: 'Essendon', postcode: '3040', state: 'VIC' },
  { suburb: 'Moonee Ponds', postcode: '3039', state: 'VIC' },
  { suburb: 'Hawthorn', postcode: '3122', state: 'VIC' },
  { suburb: 'Camberwell', postcode: '3124', state: 'VIC' },
  { suburb: 'Malvern', postcode: '3144', state: 'VIC' },
  { suburb: 'Prahran', postcode: '3181', state: 'VIC' },
  
  // QLD - Major suburbs
  { suburb: 'Brisbane', postcode: '4000', state: 'QLD' },
  { suburb: 'Fortitude Valley', postcode: '4006', state: 'QLD' },
  { suburb: 'South Brisbane', postcode: '4101', state: 'QLD' },
  { suburb: 'West End', postcode: '4101', state: 'QLD' },
  { suburb: 'New Farm', postcode: '4005', state: 'QLD' },
  { suburb: 'Paddington', postcode: '4064', state: 'QLD' },
  { suburb: 'Toowong', postcode: '4066', state: 'QLD' },
  { suburb: 'Indooroopilly', postcode: '4068', state: 'QLD' },
  { suburb: 'Chermside', postcode: '4032', state: 'QLD' },
  { suburb: 'Carindale', postcode: '4152', state: 'QLD' },
  { suburb: 'Sunnybank', postcode: '4109', state: 'QLD' },
  { suburb: 'Logan', postcode: '4114', state: 'QLD' },
  { suburb: 'Ipswich', postcode: '4305', state: 'QLD' },
  { suburb: 'Gold Coast', postcode: '4217', state: 'QLD' },
  { suburb: 'Surfers Paradise', postcode: '4217', state: 'QLD' },
  { suburb: 'Broadbeach', postcode: '4218', state: 'QLD' },
  { suburb: 'Southport', postcode: '4215', state: 'QLD' },
  { suburb: 'Robina', postcode: '4226', state: 'QLD' },
  { suburb: 'Sunshine Coast', postcode: '4558', state: 'QLD' },
  { suburb: 'Maroochydore', postcode: '4558', state: 'QLD' },
  { suburb: 'Noosa', postcode: '4567', state: 'QLD' },
  { suburb: 'Cairns', postcode: '4870', state: 'QLD' },
  { suburb: 'Townsville', postcode: '4810', state: 'QLD' },
  { suburb: 'Toowoomba', postcode: '4350', state: 'QLD' },
  { suburb: 'Rockhampton', postcode: '4700', state: 'QLD' },
  { suburb: 'Mackay', postcode: '4740', state: 'QLD' },
  { suburb: 'Bundaberg', postcode: '4670', state: 'QLD' },
  { suburb: 'Hervey Bay', postcode: '4655', state: 'QLD' },
  { suburb: 'Gladstone', postcode: '4680', state: 'QLD' },
  { suburb: 'Redcliffe', postcode: '4020', state: 'QLD' },
  
  // WA - Major suburbs
  { suburb: 'Perth', postcode: '6000', state: 'WA' },
  { suburb: 'Fremantle', postcode: '6160', state: 'WA' },
  { suburb: 'Subiaco', postcode: '6008', state: 'WA' },
  { suburb: 'Northbridge', postcode: '6003', state: 'WA' },
  { suburb: 'Leederville', postcode: '6007', state: 'WA' },
  { suburb: 'Mount Lawley', postcode: '6050', state: 'WA' },
  { suburb: 'Victoria Park', postcode: '6100', state: 'WA' },
  { suburb: 'Cannington', postcode: '6107', state: 'WA' },
  { suburb: 'Joondalup', postcode: '6027', state: 'WA' },
  { suburb: 'Mandurah', postcode: '6210', state: 'WA' },
  { suburb: 'Rockingham', postcode: '6168', state: 'WA' },
  { suburb: 'Bunbury', postcode: '6230', state: 'WA' },
  { suburb: 'Geraldton', postcode: '6530', state: 'WA' },
  { suburb: 'Kalgoorlie', postcode: '6430', state: 'WA' },
  { suburb: 'Albany', postcode: '6330', state: 'WA' },
  { suburb: 'Scarborough', postcode: '6019', state: 'WA' },
  { suburb: 'Cottesloe', postcode: '6011', state: 'WA' },
  { suburb: 'Claremont', postcode: '6010', state: 'WA' },
  { suburb: 'Nedlands', postcode: '6009', state: 'WA' },
  { suburb: 'Morley', postcode: '6062', state: 'WA' },
  
  // SA - Major suburbs
  { suburb: 'Adelaide', postcode: '5000', state: 'SA' },
  { suburb: 'North Adelaide', postcode: '5006', state: 'SA' },
  { suburb: 'Glenelg', postcode: '5045', state: 'SA' },
  { suburb: 'Brighton', postcode: '5048', state: 'SA' },
  { suburb: 'Marion', postcode: '5043', state: 'SA' },
  { suburb: 'Modbury', postcode: '5092', state: 'SA' },
  { suburb: 'Elizabeth', postcode: '5112', state: 'SA' },
  { suburb: 'Port Adelaide', postcode: '5015', state: 'SA' },
  { suburb: 'Mount Gambier', postcode: '5290', state: 'SA' },
  { suburb: 'Whyalla', postcode: '5600', state: 'SA' },
  { suburb: 'Murray Bridge', postcode: '5253', state: 'SA' },
  { suburb: 'Port Lincoln', postcode: '5606', state: 'SA' },
  { suburb: 'Victor Harbor', postcode: '5211', state: 'SA' },
  { suburb: 'Norwood', postcode: '5067', state: 'SA' },
  { suburb: 'Unley', postcode: '5061', state: 'SA' },
  { suburb: 'Prospect', postcode: '5082', state: 'SA' },
  { suburb: 'Burnside', postcode: '5066', state: 'SA' },
  { suburb: 'Mitcham', postcode: '5062', state: 'SA' },
  { suburb: 'Salisbury', postcode: '5108', state: 'SA' },
  { suburb: 'Tea Tree Gully', postcode: '5091', state: 'SA' },
  
  // TAS - Major suburbs
  { suburb: 'Hobart', postcode: '7000', state: 'TAS' },
  { suburb: 'Launceston', postcode: '7250', state: 'TAS' },
  { suburb: 'Devonport', postcode: '7310', state: 'TAS' },
  { suburb: 'Burnie', postcode: '7320', state: 'TAS' },
  { suburb: 'Kingston', postcode: '7050', state: 'TAS' },
  { suburb: 'Glenorchy', postcode: '7010', state: 'TAS' },
  { suburb: 'Clarence', postcode: '7018', state: 'TAS' },
  { suburb: 'Sandy Bay', postcode: '7005', state: 'TAS' },
  { suburb: 'North Hobart', postcode: '7000', state: 'TAS' },
  { suburb: 'Battery Point', postcode: '7004', state: 'TAS' },
  { suburb: 'Ulverstone', postcode: '7315', state: 'TAS' },
  { suburb: 'Wynyard', postcode: '7325', state: 'TAS' },
  { suburb: 'Sorell', postcode: '7172', state: 'TAS' },
  { suburb: 'New Norfolk', postcode: '7140', state: 'TAS' },
  { suburb: 'George Town', postcode: '7253', state: 'TAS' },
  
  // ACT - Major suburbs
  { suburb: 'Canberra', postcode: '2600', state: 'ACT' },
  { suburb: 'Civic', postcode: '2601', state: 'ACT' },
  { suburb: 'Belconnen', postcode: '2617', state: 'ACT' },
  { suburb: 'Tuggeranong', postcode: '2900', state: 'ACT' },
  { suburb: 'Woden', postcode: '2606', state: 'ACT' },
  { suburb: 'Gungahlin', postcode: '2912', state: 'ACT' },
  { suburb: 'Braddon', postcode: '2612', state: 'ACT' },
  { suburb: 'Kingston', postcode: '2604', state: 'ACT' },
  { suburb: 'Manuka', postcode: '2603', state: 'ACT' },
  { suburb: 'Dickson', postcode: '2602', state: 'ACT' },
  { suburb: 'Fyshwick', postcode: '2609', state: 'ACT' },
  { suburb: 'Phillip', postcode: '2606', state: 'ACT' },
  { suburb: 'Queanbeyan', postcode: '2620', state: 'ACT' },
  
  // NT - Major suburbs
  { suburb: 'Darwin', postcode: '0800', state: 'NT' },
  { suburb: 'Palmerston', postcode: '0830', state: 'NT' },
  { suburb: 'Alice Springs', postcode: '0870', state: 'NT' },
  { suburb: 'Katherine', postcode: '0850', state: 'NT' },
  { suburb: 'Nhulunbuy', postcode: '0880', state: 'NT' },
  { suburb: 'Casuarina', postcode: '0810', state: 'NT' },
  { suburb: 'Nightcliff', postcode: '0810', state: 'NT' },
  { suburb: 'Stuart Park', postcode: '0820', state: 'NT' },
  { suburb: 'Parap', postcode: '0820', state: 'NT' },
  { suburb: 'Fannie Bay', postcode: '0820', state: 'NT' },
];

export default function Hero() {
  const [searchLocation, setSearchLocation] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState<typeof australianSuburbs>([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const navigate = useNavigate();
  const searchRef = useRef<HTMLDivElement>(null);

  // Filter suggestions based on input
  useEffect(() => {
    if (searchLocation.trim().length > 0) {
      const filtered = australianSuburbs.filter(item => {
        const searchTerm = searchLocation.toLowerCase();
        return (
          item.suburb.toLowerCase().includes(searchTerm) ||
          item.postcode.includes(searchTerm)
        );
      }).slice(0, 8); // Limit to 8 suggestions
      
      setFilteredSuggestions(filtered);
      setShowSuggestions(filtered.length > 0);
    } else {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
    }
    setSelectedIndex(-1);
  }, [searchLocation]);

  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearch = (location?: string) => {
    const searchTerm = location || searchLocation;
    const params = new URLSearchParams();
    if (searchTerm) params.append('location', searchTerm);
    params.append('view', 'map'); // Add map view parameter
    navigate(`/browse?${params.toString()}`);
    setShowSuggestions(false);
  };

  const handleSuggestionClick = (suburb: string, postcode: string) => {
    const locationText = `${suburb}, ${postcode}`;
    setSearchLocation(locationText);
    setShowSuggestions(false);
    handleSearch(locationText);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      if (selectedIndex >= 0 && selectedIndex < filteredSuggestions.length) {
        const selected = filteredSuggestions[selectedIndex];
        handleSuggestionClick(selected.suburb, selected.postcode);
      } else {
        handleSearch();
      }
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelectedIndex(prev => 
        prev < filteredSuggestions.length - 1 ? prev + 1 : prev
      );
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelectedIndex(prev => prev > 0 ? prev - 1 : -1);
    } else if (e.key === 'Escape') {
      setShowSuggestions(false);
    }
  };

  return (
    <div className="relative min-h-[700px] md:h-[600px] flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20Australian%20suburban%20neighborhood%20with%20clean%20driveways%2C%20garages%2C%20and%20well-maintained%20homes%20under%20bright%20blue%20sky%2C%20aerial%20view%20showing%20organized%20residential%20streets%20with%20parking%20spaces%20and%20storage%20areas%2C%20professional%20real%20estate%20photography%20style%20with%20natural%20lighting%20and%20vibrant%20colors&width=1920&height=800&seq=hero-bg-001&orientation=landscape')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/55 via-blue-800/50 to-blue-700/45"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 w-full py-8 md:py-0 -mt-2.5">
        <div className="max-w-7xl mx-auto">
          {/* New Headline */}
          <div className="mb-4 md:mb-6">
            <span className="inline-block px-4 md:px-8 py-2 md:py-4 bg-[#2563eb] text-white text-lg md:text-2xl lg:text-3xl font-bold tracking-wide rounded-xl">
              Stashly is Disrupting the Storage Space Industry
            </span>
          </div>

          <h1 className="text-2xl md:text-5xl lg:text-6xl font-bold text-white mb-8 md:mb-12 leading-tight drop-shadow-lg">
            Turn your unused space into income !
          </h1>

          {/* Simplified Search Bar with Autocomplete */}
          <div className="max-w-3xl mx-auto mb-6 md:mb-8" ref={searchRef}>
            <div className="bg-white/95 backdrop-blur-sm rounded-full shadow-2xl p-2 relative">
              <div className="flex items-center gap-2">
                <div className="relative flex-1">
                  <i className="ri-map-pin-line absolute left-5 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl"></i>
                  <textarea
                    placeholder="Suburb&#10;Postcode"
                    value={searchLocation}
                    onChange={(e) => setSearchLocation(e.target.value)}
                    onKeyDown={handleKeyPress}
                    onFocus={() => {
                      if (filteredSuggestions.length > 0) {
                        setShowSuggestions(true);
                      }
                    }}
                    className="w-full pl-14 pr-6 py-4 md:py-5 bg-transparent border-none focus:outline-none text-base md:text-lg text-gray-800 placeholder-gray-400 resize-none overflow-hidden"
                    autoComplete="off"
                    rows={1}
                    style={{ lineHeight: '1.2' }}
                  />
                </div>
                <button 
                  onClick={() => handleSearch()}
                  className="bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-bold py-4 md:py-5 px-6 md:px-8 rounded-full transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer text-sm md:text-base shadow-lg"
                >
                  Search Spaces
                </button>
              </div>

              {/* Autocomplete Suggestions Dropdown */}
              {showSuggestions && filteredSuggestions.length > 0 && (
                <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-2xl shadow-2xl overflow-hidden z-50 max-h-80 overflow-y-auto">
                  {filteredSuggestions.map((item, index) => (
                    <button
                      key={`${item.suburb}-${item.postcode}`}
                      onClick={() => handleSuggestionClick(item.suburb, item.postcode)}
                      className={`w-full px-6 py-4 text-left hover:bg-blue-50 transition-colors cursor-pointer flex items-center gap-3 border-b border-gray-100 last:border-b-0 ${
                        index === selectedIndex ? 'bg-blue-50' : ''
                      }`}
                    >
                      <i className="ri-map-pin-line text-blue-600 text-xl flex-shrink-0"></i>
                      <div className="flex-1">
                        <div className="font-semibold text-gray-900 text-base">
                          {item.suburb}
                        </div>
                        <div className="text-sm text-gray-600">
                          {item.postcode}, {item.state}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* CTA Button - Centered and Bigger */}
          <div className="flex justify-center">
            <Link
              to="/become-host"
              className="px-12 md:px-16 py-5 md:py-6 bg-[#2563eb] text-white font-bold text-xl md:text-2xl rounded-full hover:bg-[#1d4ed8] transition-colors shadow-lg cursor-pointer whitespace-nowrap"
            >
              <i className="ri-add-circle-line mr-2"></i>
              List Your Space
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
